import * as detachConstants from 'action-creators/device/detach/constants';
import * as listConstants from 'action-creators/device/list/constants';
import * as modifyConstants from 'action-creators/device/modify/constants';

const initialState = {
  loading: false,
  devices: [],
  showDevTools: false,
  errors: {},
};

// Reducer
const reducer = (state = initialState, action) => {
  switch (action.type) {
    // list
    case listConstants.INITIALIZE_SUCCEEDED: {
      const { showDevTools } = action.payload;
      return { ...state, showDevTools };
    }
    case listConstants.FETCH:
    case modifyConstants.MODIFY:
    case detachConstants.DETACH:
      return { ...state, loading: true };
    case listConstants.FETCH_SUCCEEDED: {
      const { devices } = action.payload;
      return { ...state, devices, loading: false };
    }
    case listConstants.FETCH_FAILED:
    case modifyConstants.MODIFY_FAILED:
    case detachConstants.DETACH_FAILED: {
      const { error } = action.payload;
      return { ...state, errors: error, loading: false };
    }
    // modify
    case modifyConstants.MODIFY_SUCCEEDED: {
      const { deviceId, deviceName } = action.payload;
      return {
        ...state,
        loading: false,
        devices: state.devices.map(device => {
          if (device.device_id === deviceId) {
            return {
              ...device,
              device_name: deviceName,
            };
          }
          return device;
        }),
      };
    }
    // detach
    case detachConstants.DETACH_SUCCEEDED: {
      const { deviceId } = action.payload;
      return {
        ...state,
        devices: state.devices.filter(device => device.device_id !== deviceId),
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default reducer;
